











import {Component, Vue} from 'vue-property-decorator';
import Header from '@/components/Header/Header.vue';
import store from '@/assets/common/store/store';
import { LoginUser } from './types/Component';
  
@Component({
  components: {
    Header
  },
})
export default class App extends Vue {
    isHeaderModalOpen = false
    isHeaderInert = false
    get loginUser(): LoginUser {
      return this.$store.getters.loginUser;
    }
    mounted() {
    window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
    window.onunload = function(){
        store.dispatch('doUpdateIsInputChanged', false)
        store.dispatch('doUpdateIsTenantChanged', false)
    }
    if (store.state.reloadFromHeader) {
      store.dispatch('doUpdateReloadFromHeader', false);
    }
      this.$root.$on('header-inert', (val: boolean) => {
      this.isHeaderInert = val
    })
    this.setPageTitle()
  }

  beforeUrlChangeHandler() {
      window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
  }

  beforeUnloadHandler(event: BeforeUnloadEvent) {
    if (store.state.reloadFromHeader || !store.state.isInputChanged) {
      return;
    } else {
    event.preventDefault();
    event.returnValue = ''; // Needed for Chrome
    }
   
  }		

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
    this.$root.$off('header-inert')
  }

  private setPageTitle(): void {
    // ログインユーザーが農薬使用計画ユーザーかどうかを判定
    const isPesticidePlan = this.loginUser.isPesticidePlan;
    // ログインユーザーが農薬使用計画の生産者かどうかを判定
    const pesticidePlanProducer = this.loginUser.pesticidePlanProducer
    // 農薬使用計画ユーザーまたは生産者の場合は「ベジパレットコネクト」を表示
    if(isPesticidePlan||pesticidePlanProducer){
      document.title = 'ベジパレットコネクト'
    }else{
      // 通常ユーザーの場合は「ベジパレット」を表示
       document.title = 'ベジパレット'
    }
  }
}
